<template>
  <div class="content-left">
    <div class="left-title">
      <div class="left-title-text">组织架构</div>
      <div v-if="showBtn" class="left-title-text">
        <el-icon @click="addOrganization" class="top-icon"
          ><CirclePlusFilled
        /></el-icon>
        <img
          @click="editOrganization"
          class="top-icon"
          src="@/assets/svgs/o-edit.svg"
          alt=""
        />
        <img
          @click="delOrganization"
          class="top-icon"
          src="@/assets/svgs/o-delete.svg"
          alt=""
        />
      </div>
    </div>
    <div class="left-item">
      <el-tree
        :props="defaultProps"
        @node-click="handleNodeClick"
        :load="loadNode"
        lazy
        ref="treeRef"
        node-key="id"
        :expand-on-click-node="false"
        highlight-current
      />
    </div>
    <!-- 新增组织 -->
    <Dialog
      width="30%"
      v-model="dialogVisible"
      title="新增组织"
      top="5vh"
      @close="resetForm"
    >
      <el-form style="margin-bottom: 30px; padding: 0 50px">
        <el-form-item label="组织名称:">
          <el-input v-model="formData.name"></el-input>
        </el-form-item>
        <template v-if="!currentUnit.parentId">
          <el-form-item label="组织类型:">
            <el-select v-model="formData.type" placeholder="">
              <el-option label="学校" :value="0"></el-option>
              <el-option label="公司" :value="1"></el-option>
              <el-option label="医院" :value="2"></el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="自主添加:">
            <el-radio-group v-model="formData.isTesterAdd">
              <el-radio label="是" :value="true"></el-radio>
              <el-radio label="否" :value="false"></el-radio>
            </el-radio-group>
          </el-form-item>
        </template>
      </el-form>
      <div class="submit-buttons">
        <el-button @click="dialogVisible = false">取消</el-button>
        <el-button @click="click_confirm">确定</el-button>
      </div>
    </Dialog>
  </div>
</template>
<script setup>
import { ref, nextTick } from "vue";
import { ElMessage, ElMessageBox } from 'element-plus'
import organizationApi from "@/api/organization";
import { local } from "@/utils/storage.js";
const props = defineProps({
  showBtn: {
    type: Boolean,
    default: false,
  },
});
const emits = defineEmits(["nodeClick"]);
// 左侧树结构
const defaultProps = {
  children: "children",
  label: "name",
  isLeaf: "leaf",
};
// 待选中的id，从本地缓存读取
const targetSelectId = ref(local.get('isId'))

// 左侧树结构数据
const loadNode = (node, resolve, reject) => {
  organizationApi
    .getUnitList({
      SkipCount: 0,
      MaxResultCount: 1000,
      ParentId: node.data.id,
    })
    .then((res) => {
      const list = res.data.items;
      console.log(list,"+++++++")

      // 根节点 level=0
      if (node.level === 0 && list.length > 0) {
        nextTick(() => {
          // 判断缓存里有没有 targetSelectId
          if(targetSelectId.value){
            // 在当前根列表查找目标节点
            const targetNode = list.find(item => item.id === targetSelectId.value)
            if(targetNode){
              // 找到目标节点，选中
              handleNodeClick(targetNode);
              treeRef.value.setCurrentKey(targetNode.id);
            }else{
              // 缓存id不存在，选中第一个
              const firstNode = list[0];
              handleNodeClick(firstNode);
              treeRef.value.setCurrentKey(firstNode.id);
            }
          }else{
            // 没有缓存id，默认选中第一个
            const firstNode = list[0];
            handleNodeClick(firstNode);
            treeRef.value.setCurrentKey(firstNode.id);
          }
        });
      }
      resolve(list);
    })
    .catch((err) => {
      reject();
    });
};
// 左侧节点点击事件
const treeRef = ref(null);
const currentUnit = ref({});
const lastSelectedId = ref(null); // 记录上一次选中ID
const handleNodeClick = async (data) => {
  // 选中的时候把当前id存入缓存（保留原有逻辑）
  local.set('isId', data.id)
  if (lastSelectedId.value === data.id) {
    // 重复点击：清除高亮
    treeRef.value.setCurrentKey(null);
    lastSelectedId.value = null;
    currentUnit.value = {};
    emits("nodeClick", null);
  } else {
    // 正常选中
    lastSelectedId.value = data.id;
    currentUnit.value = data;
    emits("nodeClick", data);
    treeRef.value?.setCurrentKey(data.id);
  }
};
// 新增组织模态框
const dialogVisible = ref(false);
const formData = ref({
  name: "",
  type: 0,
  isTesterAdd: true,
});
const resetForm = () => {
  formData.value = {
    name: "",
    type: 0,
    isTesterAdd: true,
  };
};
// 新增组织
const addOrganization = () => {
  dialogVisible.value = true;
};
const editOrganization = () => {
  if (!currentUnit.value.id) {
    return ElMessage.warning("请先选择组织");
  }
  Object.assign(formData.value, currentUnit.value);
  dialogVisible.value = true;
};
const delOrganization = () => {
  if (!currentUnit.value.id) {
    return ElMessage.warning("请先选择组织");
  }
  ElMessageBox.confirm("此操作将永久删除该组织, 是否继续?", "提示", {
    confirmButtonText: "确定",
    cancelButtonText: "取消",
    type: "warning",
  })
    .then(() => {
      organizationApi.delUnit(currentUnit.value.id).then(() => {
        ElMessage.success("删除成功");
        treeRef.value.remove(currentUnit.value.id);
      });
    })
    .catch(() => {});
};
// 新增确认
const click_confirm = async () => {
  if (!formData.value.name) {
    return ElMessage.warning("请输入组织名称");
  }
  let res = formData.value.id
    ? await organizationApi.editUnit(formData.value)
    : await organizationApi.addUnit(formData.value);
  if (!formData.value.id) {
    res.data.leaf = true;
    treeRef.value.append(res.data);
  } else {
    Object.assign(currentUnit.value, res.data);
  }
  ElMessage.success("操作成功");
  dialogVisible.value = false;
};
defineExpose({
  treeRef,
});
</script>
<style lang="scss" scoped>
.content-left {
  border-right: 1px solid #0f5ba2;
  width: 200px;
  background: #03386a;
  display: grid;
  grid-template-rows: auto 1fr;
  .left-title {
    background: #134e92;
    height: 40px;
    line-height: 40px;
    color: #66baec;
    display: flex;
    justify-content: space-between;
    .left-title-text {
      margin: 0 10px;
      display: flex;
      align-items: center;
      .top-icon {
        width: 15px;
        height: auto;
        margin-left: 10px;
        cursor: pointer;
      }
      svg {
        width: 100%;
        height: 100%;
      }
    }
  }
  .left-item {
    padding: 10px 20px;
    max-height: 60vh;
    overflow: auto;
  }
}
.el-tree {
  background: #03386a;
  color: #66baec;
  :deep() {
    --el-tree-node-hover-bg-color: #134e92;
    --el-color-primary-light-9: #124e91;
    .el-tree-node__content {
      padding: 6px 0;
      box-sizing: border-box;
      min-height: 36px;
      height: auto;
      border-radius: 4px;
      white-space: normal;
      background-color: transparent;
      &:active,
      &:focus,
      &:focus-visible {
        background-color: transparent !important;
        outline: none;
      }
      &:hover {
        background-color: #134e92;
      }
    }
    .el-tree-node.is-current > .el-tree-node__content {
      background-color: #0f5ba2;
    }
    .el-text.is-truncated {
      color: #66baec !important;
      overflow: unset !important;
      text-overflow: clip !important;
      white-space: normal !important;
      display: block !important;
    }
    .el-tree-node__expand-icon {
      color: #66baec !important;
    }
  }
}
</style>
